(function () {
  'use strict';

  function initGallery(root) {
    const main = root.querySelector('#LcPdpMainImg') || root.querySelector('.lc-pdp__main-img');
    const thumbs = root.querySelectorAll('[data-lc-pdp-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const src = btn.getAttribute('data-full-src');
        const alt = btn.getAttribute('data-alt') || '';
        if (src) {
          main.src = src;
          main.alt = alt;
        }
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === btn);
        });
      });
    });

    root.querySelector('[data-lc-pdp-zoom]')?.addEventListener('click', function () {
      if (main.requestFullscreen) main.requestFullscreen();
      else window.open(main.src, '_blank');
    });
  }

  function initTabs(root) {
    const tabs = root.querySelectorAll('[data-lc-pdp-tab]');
    const panels = root.querySelectorAll('[data-lc-pdp-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const id = tab.getAttribute('data-lc-pdp-tab');
        tabs.forEach(function (t) {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-lc-pdp-panel') !== id;
        });
      });
    });
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return '₹' + (cents / 100).toFixed(0);
  }

  function initVariants(root) {
    const form = root.querySelector('.lc-pdp__form');
    if (!form) return;
    const idInput = form.querySelector('[name="id"]');
    const priceEl = root.querySelector('[data-lc-pdp-price]');
    const compareEl = root.querySelector('[data-lc-pdp-compare]');
    const jsonEl = root.querySelector('[data-lc-pdp-variants-json]');
    if (!idInput || !jsonEl) return;

    let variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (_) {
      return;
    }

    function matchVariant() {
      const selected = [];
      form.querySelectorAll('[data-lc-pdp-option].is-selected').forEach(function (btn) {
        selected[Number(btn.getAttribute('data-option-index'))] = btn.getAttribute('data-value');
      });
      const match = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          if (selected[i] == null || selected[i] === '') return true;
          return opt === selected[i];
        });
      });
      if (!match) return;
      const weightRoot = root.querySelector('[data-lc-gem-weight]');
      const weightLocksVariant =
        weightRoot && weightRoot.dataset.lcGemWeightSelected === '1' && weightRoot.dataset.lcResolvedVariantId;
      if (!weightLocksVariant) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
      }
      root.dispatchEvent(
        new CustomEvent('lc:pdp-variant-changed', {
          bubbles: true,
          detail: { variantId: match.id, priceCents: match.price },
        })
      );
      if (compareEl) {
        if (match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = !match.available;
    }

    form.querySelectorAll('[data-lc-pdp-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const group = btn.getAttribute('data-option-index');
        form
          .querySelectorAll('[data-lc-pdp-option][data-option-index="' + group + '"]')
          .forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
          });
        matchVariant();
      });
    });
  }

  function lineItemProperties(form) {
    const props = Object.create(null);
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      const match = el.name.match(/^properties\[(.+)\]$/);
      if (!match || !el.value) return;
      props[match[1]] = el.value;
    });
    return props;
  }

  function initBeadSize(root) {
    const form = root.querySelector('.lc-pdp__form');
    const beadRoot = root.querySelector('[data-lc-bead-size]');
    if (!form || !beadRoot) return;

    const select = beadRoot.querySelector('[data-lc-bead-size-select]');
    const idInput = form.querySelector('[name="id"]');
    const priceEl = root.querySelector('[data-lc-pdp-price]');
    const compareEl = root.querySelector('[data-lc-pdp-compare]');
    const submit = form.querySelector('[type="submit"]');
    if (!select || !idInput) return;

    function applyBeadSelection() {
      const opt = select.options[select.selectedIndex];
      if (!opt || !opt.value) {
        beadRoot.dataset.lcBeadSizeSelected = '';
        idInput.value = '';
        if (submit) submit.disabled = true;
        return;
      }
      const priceCents = Number(opt.getAttribute('data-price-cents')) || 0;
      const compareCents = Number(opt.getAttribute('data-compare-cents')) || 0;
      idInput.value = opt.value;
      beadRoot.dataset.lcBeadSizeSelected = '1';
      if (priceEl && priceCents) priceEl.textContent = formatMoney(priceCents);
      if (compareEl) {
        if (compareCents > priceCents) {
          compareEl.textContent = formatMoney(compareCents);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submit) submit.disabled = opt.disabled;
      root.dispatchEvent(
        new CustomEvent('lc:pdp-variant-changed', {
          bubbles: true,
          detail: { variantId: opt.value, priceCents: priceCents },
        })
      );
    }

    select.addEventListener('change', applyBeadSelection);

    form.addEventListener(
      'submit',
      function (evt) {
        if (!beadRoot.dataset.lcBeadSizeSelected) {
          evt.preventDefault();
          select.focus();
          if (select.reportValidity) select.reportValidity();
        }
      },
      true
    );

    if (form.dataset.lcBeadBuyNowBound === '1' || !window.lcAddToCart) return;
    form.dataset.lcBeadBuyNowBound = '1';

    form.addEventListener(
      'click',
      async function (e) {
        const pay = e.target.closest(
          '.shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout'
        );
        if (!pay) return;
        if (!beadRoot.dataset.lcBeadSizeSelected) {
          e.preventDefault();
          e.stopPropagation();
          select.focus();
          if (select.reportValidity) select.reportValidity();
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        const id = idInput.value;
        const qty = form.querySelector('[name="quantity"]')?.value || 1;
        try {
          await window.lcAddToCart(id, qty, {});
          window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
        } catch (err) {
          window.alert(err.message || 'Could not start checkout.');
        }
      },
      true
    );
  }

  function initGemWeightBuyNow(root) {
    const form = root.querySelector('.lc-pdp__form');
    const weightRoot = root.querySelector('[data-lc-gem-weight]');
    if (!form || !weightRoot || !window.lcAddToCart) return;
    if (form.dataset.lcGemBuyNowBound === '1') return;
    form.dataset.lcGemBuyNowBound = '1';

    form.addEventListener(
      'click',
      async function (e) {
        const pay = e.target.closest(
          '.shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout'
        );
        if (!pay) return;

        if (!weightRoot.dataset.lcGemWeightSelected) {
          e.preventDefault();
          e.stopPropagation();
          const sel = weightRoot.querySelector('[data-lc-gem-weight-select]');
          if (sel) {
            sel.focus();
            if (sel.reportValidity) sel.reportValidity();
          }
          return;
        }

        if (weightRoot.dataset.lcCheckoutPriceReady === '0') {
          e.preventDefault();
          e.stopPropagation();
          window.alert(
            weightRoot.getAttribute('data-checkout-blocked-msg') ||
              'This weight is not available for checkout yet. Please select the default weight (base price) or contact support.'
          );
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        const id =
          weightRoot.dataset.lcResolvedVariantId || form.querySelector('[name="id"]')?.value;
        const qty = form.querySelector('[name="quantity"]')?.value || 1;
        const props = lineItemProperties(form);
        try {
          await window.lcAddToCart(id, qty, props);
          if (
            document.body.classList.contains('lc-gift-upsell-active') ||
            document.body.dataset.lcGiftUpsellActive === '1' ||
            document.querySelector('[data-lc-gift-upsell-config]')
          ) {
            return;
          }
          window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
        } catch (err) {
          window.alert(err.message || 'Could not start checkout.');
        }
      },
      true
    );
  }

  function initForm(root) {
    const form = root.querySelector('.lc-pdp__form');
    if (!form || !window.lcAddToCart) return;
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const beadRoot = root.querySelector('[data-lc-bead-size]');
      if (beadRoot && !beadRoot.dataset.lcBeadSizeSelected) {
        const sel = beadRoot.querySelector('[data-lc-bead-size-select]');
        if (sel) {
          sel.focus();
          if (sel.reportValidity) sel.reportValidity();
        }
        return;
      }
      const weightRoot = root.querySelector('[data-lc-gem-weight]');
      if (weightRoot && !weightRoot.dataset.lcGemWeightSelected) {
        const sel = weightRoot.querySelector('[data-lc-gem-weight-select]');
        if (sel) {
          sel.focus();
          if (sel.reportValidity) sel.reportValidity();
        }
        return;
      }
      let id = form.querySelector('[name="id"]')?.value;
      if (weightRoot?.dataset.lcCheckoutPriceReady === '0') {
        window.alert(
          weightRoot.getAttribute('data-checkout-blocked-msg') ||
            'This weight is not available for checkout yet. Please select the default weight (base price) or contact support.'
        );
        return;
      }
      if (weightRoot?.dataset.lcResolvedVariantId) {
        id = weightRoot.dataset.lcResolvedVariantId;
      }
      const qty = form.querySelector('[name="quantity"]')?.value || 1;
      const props = lineItemProperties(form);
      const btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      try {
        await window.lcAddToCart(id, qty, props);
      } catch (err) {
        alert(err.message || 'Could not add to cart');
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  }

  document.querySelectorAll('[data-lc-pdp]').forEach(function (root) {
    initGallery(root);
    initTabs(root);
    initVariants(root);
    initBeadSize(root);
    initForm(root);
    initGemWeightBuyNow(root);
  });
})();
